import React, { useEffect, useState } from "react";
import { PlusIconCircle } from "../../../Icon";
import { formatDate, handleDate } from "../../../../utils/commonFunctions";
import {
  getSchedulingBandWidthAction,
  resetSchedulingPrevoiusHour,
} from "../../../../redux/scheduling";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import OneTimeEstimateInput from "./OneTimeEstimateInput";

type AppProps = {
  dispatchGetSchedulingBandWidthAction: (data: any) => void;
  token: string | null;
  previousHours: number;
  // onStateChange: any;
  dispatchResetPrevoiusHour: () => void;
  handleAddEstimateData: any;
  oneTimeEstimateData: any;
  setOneTimeEstimateData: any;
  persistDateRange:any;
  oneTimeEstimateDataInput: any;
  update?:string|undefined;
  userId?:number|undefined;
  showSchedulingEstimateData:any;
  setPersistDateRange:any;
  setGetRestimateHours:any;
  setInputChange:any;
  disableDate:any;
  reEstimateData:any;
  setJobIndex:any;
  setJobInput:any;
  dailyHours:any;
  jobData:string;
  setDateArray:any;
};
const OneTimeEstimate = ({
  dispatchGetSchedulingBandWidthAction,
  token,
  previousHours,
  reEstimateData,
  dispatchResetPrevoiusHour,
  handleAddEstimateData,
  oneTimeEstimateData,
  setOneTimeEstimateData,
  oneTimeEstimateDataInput,
  persistDateRange,
  userId,
  update,
  showSchedulingEstimateData,
  setPersistDateRange,
  setInputChange,
  setGetRestimateHours,
  disableDate,
  setJobIndex,
  setJobInput,
  setDateArray,
  dailyHours,
  jobData
}: AppProps) => {
 

  const [dateResult, setDateResult] = useState<number>(0);
  // const [date, setDate] = useState<string>("");
  const [hoursInput, sethoursInput] = useState<number | null>(null);
  const [index, setIndex] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [hasError, setHasError] = useState(false);
  const [date, setDate] = useState("");
  const [dateChange, setDateChange] = useState<any>("");
  const [dateIndex,setDateIndex]=useState<number>(0);


  useEffect(() => {
    dispatchResetPrevoiusHour();
  }, []);


  useEffect(() => {
    let result = oneTimeEstimateData.reduce(function (acc:any, obj:any) { return +acc + +obj.hours; }, 0);
    setTotal(result)
  }, [hoursInput,index, oneTimeEstimateData]);

  const handleDateChange = (date: any, i: number, dataKey: any) => {
    dispatchResetPrevoiusHour();
    if(date!="Invalid date"){
      setDateChange(date)
      setDateIndex(i)
      let temp = JSON.parse(JSON.stringify(oneTimeEstimateData));
     
      const value = handleDate(date);
      setDate?.(value);
      temp[i][dataKey] = value;
      //
      // temp[i]['progressCount'] = oneTimeEstimateData[i]?.progressCount;
      temp[i]["progressCount"] = +previousHours;
      temp[i]["previoushours"] = +previousHours;
      temp[i]["errorMessage"] ="";
    
      setOneTimeEstimateData([...temp]);
      if (update&&userId) {
        
        let finalData = {
          token,
          date: formatDate(date),
          user_id:userId
      };
      
      dispatchGetSchedulingBandWidthAction(finalData);
      }
      else {
        
        let finalData = {
          token,
          date: formatDate(date),
        };
        dispatchGetSchedulingBandWidthAction(finalData);
      }

      temp[i]["hours"] = "";
    }
  };

  useEffect(()=>{
    if(previousHours || previousHours==0 && jobData=="oneTime"){
      let temp = JSON.parse(JSON.stringify(oneTimeEstimateData));

      if(temp && temp?.length && dateIndex>=0){
        temp[dateIndex]["progressCount"] = +previousHours;
        temp[dateIndex]["previoushours"] = +previousHours;
        temp[dateIndex]["errorMessage"] ="";
      }
      
      setPersistDateRange([...temp])
      setOneTimeEstimateData([...temp]);
      setGetRestimateHours([...temp])
    }

  
  },[previousHours,dateChange,dateIndex])




  const handleHoursChange = (
    value: any,
    i: number,
    dataKey: any,
    date: string
  ) => {
    setDate(date);
    setInputChange(false);
    let inputValue = Number(value);
  
    let temp = JSON.parse(JSON.stringify(oneTimeEstimateData));
    sethoursInput(value);
    setIndex(i)
  
    setJobIndex(i)
    setJobInput(inputValue)
    let checkingValidation= inputValue <= (12 - +temp[i]["progressCount"])
    temp[i]["hours"] = inputValue;

    if(temp[i]["requestId"] && !update ){
      let newInputValue= persistDateRange[i]["progressCount"]-persistDateRange[i]["previoushours"];
      temp[i]["progressCount"]= +newInputValue + +inputValue;
    }


    if(checkingValidation){
    temp[i]["errorMessage"] ="";
    }
    else if(!temp[i]["requestId"] && (temp[i]["progressCount"] || temp[i]['hours']>12)){
      temp[i]["errorMessage"] =`Maximum ${+(12 - (+temp[i]["progressCount"]?+temp[i]["progressCount"]:0))?.toFixed(2)} hours remaining for the day`
    }
    else if(temp[i]["requestId"] &&  temp[i]["progressCount"]>12 && !update){
      temp[i]["errorMessage"] =`Error! Maximum hours for the day exceeded`  
    }
    else{
      temp[i]["errorMessage"] ="";
    }
    setOneTimeEstimateData([...temp]);
    setGetRestimateHours([...temp])
   
  };

  

  const handleRemoveRow = (index: number) => {
    let temp = JSON.parse(JSON.stringify(oneTimeEstimateData));
    temp.splice(index, 1);
    setOneTimeEstimateData([...temp]);
    setGetRestimateHours([...temp])
  };
  const handleAddAnotherRow = () => {
    setInputChange(false);
    let temp = JSON.parse(JSON.stringify(oneTimeEstimateData));
    temp.push(...JSON.parse(JSON.stringify(oneTimeEstimateDataInput)));
    setOneTimeEstimateData([...temp]);
    setGetRestimateHours([...temp]);
  };

  return (
    <>


      <div className="mt-5" style={{ width: "100%" }}>
        <div className="jobsType">
          <table className="table table-bordered thead-light">
            <thead
              className="text-start "
              style={{
                backgroundColor: "#f4f6f8",
                color: "#464f60",
                fontSize: "12px",
                fontWeight: "600",
              }}
            >
              <tr
                style={{
                  color: "#464f60",
                  backgroundColor: "#e8ecf0",
                }}
              >
                <div
                  className=""
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "10px",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{width:"200px"}}> TOTAL</div>

                  <div style={{width:"300px",display:"flex", justifyContent:"center"}}>{total?.toFixed(2)}</div>
                  <div style={{width:"400px"}}></div>
                </div>
              </tr>
              <tr style={{
                color: "#464f60",
                backgroundColor: "#f4f6f8",
              }}>
                <div
                  className="sticky-table-header-without-zindex"
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "10px",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{width:"200px"}}> DATE</div>

                  <div style={{width:"315px",display:"flex", justifyContent:"center" }}>Hours</div>
                  <div style={{width:"400px",display:"flex", justifyContent:"center" }}>{update ? "Employee scheduled hours" : "Your scheduled hours"}</div>
                </div>
   
              </tr>
            </thead>
            <tbody style={{ alignItems: "center" }} className="col-md-12">
              <OneTimeEstimateInput
                previousHours={previousHours}
                oneTimeEstimateData={oneTimeEstimateData}
                handleDateChange={handleDateChange}
                handleHoursChange={handleHoursChange}
                handleRemoveRow={handleRemoveRow}
                hasError={hasError}
                oneTimeEstimateDataInput={oneTimeEstimateDataInput}
                dispatchResetPrevoiusHour={dispatchResetPrevoiusHour}
                showSchedulingEstimateData={showSchedulingEstimateData}
                disableDate={disableDate}
              />

              <tr>
                <td>
                  <button
                    className="btn btn-outline"
                    onClick={handleAddAnotherRow}
                  >
                    <span>
                      <PlusIconCircle /> {oneTimeEstimateData?.length===0?"Add":"Add More"}
                    </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};


const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  previousHours: state.scheduling.previousHours,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetSchedulingBandWidthAction: (data: any) => {
    dispatch(getSchedulingBandWidthAction(data));
  },
  dispatchResetPrevoiusHour: () => {
    dispatch(resetSchedulingPrevoiusHour());
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(OneTimeEstimate);
